export const getAllElements = () => {
  const elements = Array.from(
    document.getElementsByClassName('projects__item'),
  );

  return elements.filter(element => !element.dataset.cloned);
};
